import React from "react";
import SignIn from "../auth/SignIn";

export default function MustBeLoggedIn(): React.ReactElement {
  const handleClose = () => {
    console.log("close sign in");
  };
  return <SignIn handleClose={handleClose} isOpen={true} />;
}
